"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initKakao = void 0;
/**
 * Kakao Javascript SDK 동적으로 불러오고 초기화 시킨다.
 * @param {string} javascript키
 * @returns {Promise} SDK 로드 여부
 */
const initKakao = (jsKey) => {
    return new Promise((resolve, reject) => {
        if (typeof window !== "undefined") {
            var script = document.createElement("script");
            script.onload = function () {
                // console.log("onload : ", document);
                window.Kakao.init(jsKey);
                resolve(true);
            };
            script.onerror = (e) => {
                reject(e);
            };
            script.src = "https://t1.kakaocdn.net/kakao_js_sdk/2.0.1/kakao.min.js";
            script.integrity =
                "sha384-eKjgHJ9+vwU/FCSUG3nV1RKFolUXLsc6nLQ2R1tD0t4YFPCvRmkcF8saIfOZNWf/";
            script.crossOrigin = "anonymous";
            document.head.appendChild(script);
        }
        else {
            // console.info("Loading Kakao...");
            // resolve(false);
        }
    });
};
exports.initKakao = initKakao;
